export const BATCH_SCROLL = "events.batchScroll";
export const BATCH_SCROLL_UPDATE = "events.batchScrollUpdate";
